import { RootState } from 'common/redux/core/root.reducer';

export const getEntityDetailsResponse = (state: RootState) => state.entity.entityDetails;

export const getCategoryDetailsForEdit = (state: RootState) => state.entity.categoryDetails;

export const getIndicatorDetailsForEdit = (state: RootState) => state.entity.indicatorDetails;

export const getSourceList = (state: RootState) => state.entity.sources;
